
























import Vue from 'vue'
import { Portal } from 'portal-vue'
import SimpleModalBox from '@/components/modal/basics/SimpleModal/SimpleModalBox.vue'
import SimpleModalFooterButton from '@/components/modal/basics//SimpleModal/SimpleModalFooterButton.vue'

export default Vue.extend({
  components: {
    Portal,
    SimpleModalBox,
    SimpleModalFooterButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data(vm: any) {
    return {
      showSnackModal: vm.show,
    }
  },
  watch: {
    show() {
      this.showSnackModal = this.show
    },
  },
})
